import { Stack, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { AskProduct } from './AskProduct';
import { CallToAction } from './CallToAction';
import { Header } from './Header';
import { ObserveProduct } from './ObserveProduct';
import type { ChurnDeflectionAskProduct, ChurnDeflectionObserveProduct } from '../types';

type Props = {
  observeProduct: ChurnDeflectionObserveProduct;
  askProduct?: ChurnDeflectionAskProduct;
  dailySessions: number;
  subscriptionEndDate: string;
  onComparePlansClick: () => void;
  onMakeAnEnquiryClick: () => void;
};

export function ChurnDeflection({
  observeProduct,
  askProduct,
  dailySessions,
  subscriptionEndDate,
  onComparePlansClick,
  onMakeAnEnquiryClick,
}: Props): JSX.Element {
  const { t } = useTranslation('voluntary-churn');

  const isDowngradingAsk = askProduct != null;

  return (
    <Stack direction="column" customSpacing={tokens.spacer.x3}>
      <Stack direction="column" customSpacing={tokens.spacer.x3}>
        <Header subscriptionEndDate={subscriptionEndDate} />
      </Stack>
      <Stack direction="column" customSpacing={tokens.spacer.x3}>
        <ObserveProduct
          currentPlan={observeProduct.currentPlan}
          newPlan={observeProduct.newPlan}
          dailySessions={dailySessions}
          subscriptionEndDate={subscriptionEndDate}
        />
        {isDowngradingAsk && (
          <AskProduct
            currentPlan={askProduct.currentPlan}
            newPlan={askProduct.newPlan}
            subscriptionEndDate={subscriptionEndDate}
          />
        )}
      </Stack>
      <Stack>
        <CallToAction
          title={t('churn.deflection-modal.alert-compare-plans.title')}
          description={t('churn.deflection-modal.alert-compare-plans.description')}
          link={t('churn.deflection-modal.alert-compare-plans.link')}
          href={t('churn.deflection-modal.alert-compare-plans.href')}
          icon="open_new_window"
          onCtaClick={onComparePlansClick}
        />
        <CallToAction
          title={t('churn.deflection-modal.alert-make-enquiry.title')}
          description={t('churn.deflection-modal.alert-make-enquiry.description')}
          link={t('churn.deflection-modal.alert-make-enquiry.link')}
          href={t('churn.deflection-modal.alert-make-enquiry.href')}
          icon="chat"
          onCtaClick={onMakeAnEnquiryClick}
        />
      </Stack>
    </Stack>
  );
}
